// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TextCollectionModal_textCollectionsTable__jdqy- {
  width: 100%;
}
.TextCollectionModal_textCollectionsTable__assetsNumber__6zemU {
  width: 150px;
}
.TextCollectionModal_textCollectionsTable__wrapper__scroll__voai- {
  max-height: 220px;
  overflow-y: auto;
}
.TextCollectionModal_textCollectionsTable__jdqy- th {
  background: #FAFAFA;
  padding: 10px 8px;
  position: sticky;
  top: 0;
  z-index: 1;
  text-transform: capitalize;
  font-size: 14px;
}
.TextCollectionModal_textCollectionsTable__jdqy- th:nth-child(1) {
  width: 50px;
}
.TextCollectionModal_textCollectionsTable__jdqy- th:nth-child(2) {
  width: 192px;
}
.TextCollectionModal_textCollectionsTable__jdqy- th:nth-child(3) {
  width: 138px;
}
.TextCollectionModal_textCollectionsTable__jdqy- th:nth-child(4) {
  width: 364px;
}
.TextCollectionModal_textCollectionsTable__jdqy- th:not(:last-child):after {
  content: "";
  height: 25px;
  width: 1px;
  background-color: #F0F0F0;
  position: absolute;
  top: 10px;
  right: 2px;
}
.TextCollectionModal_textCollectionsTable__jdqy- td:not(:first-child) {
  padding: 0 12px;
}
.TextCollectionModal_textCollectionsTable__jdqy- tr {
  border-bottom: 1px solid #FAFAFA;
}
.TextCollectionModal_textCollectionsTable__jdqy- tr span {
  font-size: 14px;
  line-height: 22px;
  word-break: break-word;
}
.TextCollectionModal_textCollectionsTable__radio__ocp4c {
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/Modules/components/TextCollectionsModal/TextCollectionModal.module.scss","webpack://./src/styles/global-variables.scss"],"names":[],"mappings":"AAGA;EACI,WAAA;AAFJ;AAII;EACI,YAAA;AAFR;AAMQ;EACI,iBAAA;EACA,gBAAA;AAJZ;AAQI;EACI,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,MAAA;EACA,UCDuB;EDEvB,0BAAA;EACA,eAAA;AANR;AAQQ;EACI,WAAA;AANZ;AAUQ;EACI,YAAA;AARZ;AAWQ;EACI,YAAA;AATZ;AAYQ;EACI,YAAA;AAVZ;AAcY;EACI,WAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAZhB;AAiBI;EACI,eAAA;AAfR;AAkBI;EACI,gCAAA;AAhBR;AAkBQ;EACI,eAAA;EACA,iBAAA;EACA,sBAAA;AAhBZ;AAoBI;EACI,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAlBR","sourcesContent":["@use \"/home/runner/_work/gmc-dc-pbui-fe/gmc-dc-pbui-fe/src/styles/global-variables.scss\" as *;\n@import 'styles/_colors.module';\n\n.textCollectionsTable {\n    width: 100%;\n\n    &__assetsNumber {\n        width: 150px;\n    }\n\n    &__wrapper {\n        &__scroll {\n            max-height: 220px;\n            overflow-y: auto;\n        }\n    }\n\n    th {\n        background: map-get($gray, 50);\n        padding: 10px 8px;\n        position: sticky;\n        top: 0;\n        z-index: $zIndexTextCollectionsModalTh;\n        text-transform: capitalize;\n        font-size: 14px;\n\n        &:nth-child(1) {\n            width: 50px;\n        }\n\n\n        &:nth-child(2) {\n            width: 192px;\n        }\n\n        &:nth-child(3) {\n            width: 138px;\n        }\n\n        &:nth-child(4) {\n            width: 364px;\n        }\n\n        &:not(:last-child) {\n            &:after {\n                content: '';\n                height: 25px;\n                width: 1px;\n                background-color: map-get($gray, 80);\n                position: absolute;\n                top: 10px;\n                right: 2px;\n            }\n        }\n    }\n\n    td:not(:first-child) {\n        padding: 0 12px;\n    }\n\n    tr {\n        border-bottom: 1px solid map-get($gray, 50);\n\n        span {\n            font-size: 14px;\n            line-height: 22px;\n            word-break: break-word;\n        }\n    }\n\n    &__radio {\n        padding: 15px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n}","$navbarHeight: 50px;\n\n$clearSectionButtonColor: #6C757D;\n$clearAllButtonPrimary: #F8F9FA;\n$clearAllButtonDisabled: #A1BFBE;\n$borderColor: #dee2e6;\n\n$buttonBorderRadius: 3.2px;\n\n$buttonFontSize: 14px;\n\n$zIndexSimulationDisclaimer: 1000;\n$zIndexSectionWithLayoutVariantsHover: 200;\n$zIndexSectionHighlighted: 100;\n$zIndexSectionStickyPanel: 100;\n$zIndexModal: 100;\n$zIndexModalBackdrop: 10;\n$zIndexIconTitleTooltip: 2;\n$zIndexScreen: 2;\n$zIndexScreenBackdrop: 1;\n$zIndexLayoutPreviewListStickyPanel: 1;\n$zIndexTextCollectionsModalTh: 1;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textCollectionsTable": `TextCollectionModal_textCollectionsTable__jdqy-`,
	"textCollectionsTable__assetsNumber": `TextCollectionModal_textCollectionsTable__assetsNumber__6zemU`,
	"textCollectionsTable__wrapper__scroll": `TextCollectionModal_textCollectionsTable__wrapper__scroll__voai-`,
	"textCollectionsTable__radio": `TextCollectionModal_textCollectionsTable__radio__ocp4c`
};
export default ___CSS_LOADER_EXPORT___;
